import React, { Component } from "react";
import { connect } from "react-redux";
import SignUpForm from "../components/SignUpForm";
import { onUserLogin, signUpNewUser } from '../redux/actions/userActions';

class SignUpPage extends Component {
  state = {
    email: "",
    pass: "",
    passConfirm: "",
    passDoNotMatch: false,
    orgName: "",
    betaKey: "",
    terms: false,
    saveAvaliable: false,
    organizationKey: ""
  };

  componentDidUpdate() {
    const { authenticated, onUserLogin, history } = this.props;
    if (authenticated) {
      onUserLogin(history);
    }
  }

  onSave = () => {
    const { signUpNewUser, history } = this.props;
    const { email, pass, orgName, betaKey } = this.state;
    signUpNewUser({ email, pass, orgName, betaKey, history });
  };

  onEmailChange = email => this.setState({ email }, this.checkSaveAvaliable);
  onPassChange = pass => this.setState({ pass }, this.checkSaveAvaliable);
  onPassConfirmChange = passConfirm => this.setState({ passConfirm }, this.checkSaveAvaliable);
  onOrgNameChange = orgName => this.setState({ orgName }, this.checkSaveAvaliable);
  onBetaKeyChange = betaKey => this.setState({ betaKey }, this.checkSaveAvaliable);
  onTermsChange = terms => this.setState({ terms }, this.checkSaveAvaliable);

  checkSaveAvaliable = () => {
    const {
      email,
      pass,
      passConfirm,
      orgName,
      betaKey,
      terms
    } = this.state;

    this.setState({
      passDoNotMatch: pass !== passConfirm && passConfirm !== ""
    });

    let saveAvaliable = true;
    if (
      email === "" ||
      pass === "" ||
      pass !== passConfirm ||
      orgName === "" ||
      betaKey === "" ||
      !terms
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  render() {
    const { loading, errorMessage } = this.props;
    const {
      email,
      pass,
      passConfirm,
      orgName,
      betaKey,
      terms,
      saveAvaliable,
      passDoNotMatch
    } = this.state;

    return (
      <SignUpForm
        onSubmit={this.onSave}
        email={email}
        onEmailChange={this.onEmailChange}
        pass={pass}
        onPassChange={this.onPassChange}
        passConfirm={passConfirm}
        onPassConfirmChange={this.onPassConfirmChange}
        passDoNotMatch={passDoNotMatch}
        orgName={orgName}
        onOrgNameChange={this.onOrgNameChange}
        betaKey={betaKey}
        onBetaKeyChange={this.onBetaKeyChange}
        terms={terms}
        onTermsChange={this.onTermsChange}
        saveAvaliable={saveAvaliable}
        loading={loading}
        errorMessage={errorMessage}
      />
    );
  }
}

const mapStateToProps = state => ({
  users: state.data.users,
  loading: state.ui.loading,
  errorMessage: state.ui.errorMessage,
  authenticated: state.user.authenticated
});

const mapDispatchToProps = {
  signUpNewUser,
  onUserLogin
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SignUpPage);
